module.exports = __webpack_public_path__ + "static/Margaux_Olivre-34a535d0461467182bce230ec2c9f541.png";